@if (_isOpen()) {
    <form [formGroup]="form">
        @if (insurantMaxAge() > 18) {
            <p>Bitte wähle aus:</p>
            <div class="form-control">
                <input
                    type="radio"
                    id="pick-insurant-myself"
                    [value]="true"
                    formControlName="isInsuree"
                />
                <label for="pick-insurant-myself"> Ich selbst bin die versicherte Person </label>
                <p class="fs:s m-48:b">
                    Du bist
                    <strong>
                        mindestens 18
                        {{ insurantMaxAge() != 99 ? 'und höchstens ' + insurantMaxAge + ' ' : '' }}
                        Jahre alt
                    </strong>
                    und schließt diese Versicherung für dich selbst ab.
                </p>
            </div>
            <div class="form-control">
                <input
                    type="radio"
                    id="pick-insurant-other"
                    [value]="false"
                    formControlName="isInsuree"
                />
                <label for="pick-insurant-other">
                    Ich bin Erziehungs&shy;berechtigter oder Vormund der versicherten Person
                </label>
                <p class="fs:s">
                    Die versicherte Person ist <strong>unter 18 Jahren alt</strong>. Du schließt die Versicherung für
                    die im weiteren Verlauf anzugebende Person ab.
                </p>
            </div>
        }
        <!-- #region insurant is not insuree -->
        @if (showInsurantForm()) {
            <div class="grid-container p-24:t md:p-32:t lg:p-48:t">
                @if (insurantMaxAge() > 18) {
                    <div class="g-12 lg:p-48:b">
                        <h3>Versicherte Person</h3>
                        <p>Bitte vervollständige die Angaben zur versicherten Person:</p>
                    </div>
                }
                @if (insurantMaxAge() <= 18) {
                    <div class="g-12 p-12:b">
                        <p>
                            Bitte gib Name und Geburtsdatum der versicherten Person an. Diese darf nicht älter als 18
                            Jahre sein.
                        </p>
                    </div>
                }
                <div class="form-control g-12">
                    <input
                        id="input-first-name"
                        type="text"
                        placeholder="Vorname*"
                        formControlName="firstName"
                        [ctrlErrorMessage]="firstNameErrorMessages"
                        required
                    />
                </div>
                <div class="form-control g-12">
                    <label
                        for="input-last-name"
                        appReactiveLabel
                        formControlName="lastName"
                        >Nachname*:</label
                    >
                    <input
                        id="input-last-name"
                        type="text"
                        placeholder="Nachname*"
                        formControlName="lastName"
                        [ctrlErrorMessage]="lastNameErrorMessages"
                        required
                    />
                </div>
                <div class="form-control g-12">
                    <label
                        for="day-of-birth"
                        appReactiveLabel
                        formControlName="dateOfBirth"
                        >Geburtstag (tt.mm.jjjj)*:</label
                    >
                    <input
                        id="day-of-birth"
                        ctrlDateInput
                        type="text"
                        placeholder="Geburtstag (tt.mm.jjjj)*"
                        formControlName="dateOfBirth"
                        [ctrlErrorMessage]="dateOfBirthErrorMessages"
                        required
                    />
                </div>
                <div class="g-12">
                    <app-required-info></app-required-info>
                </div>
            </div>
        }
        <!-- #endregion -->
    </form>
    <app-navigation-buttons
        [nextDisabled]="form.invalid"
        [showBack]="_isFirstStep()"
        (prev)="btnPrev()"
        (next)="submit()"
        nextTooltip="Bitte fülle alle erforderlichen Felder aus."
    ></app-navigation-buttons>
}
